// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3XWpW","content":"RecentSearches_content__qqlQ8"};